import { t as toPropertyKey } from './toPropertyKey-ae5ee4b0.js';
import isDev from '@picsart/rc/isDev';

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

/* eslint-disable no-console */
var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }
  return _createClass(Logger, null, [{
    key: "info",
    value: function info(message, style) {
      isDev && console.info(message, style);
    }
  }, {
    key: "success",
    value: function success(message) {
      isDev && console.log("%c ".concat(message), 'color:green');
    }
  }, {
    key: "error",
    value: function error(message) {
      isDev && console.trace(message);
    }
  }, {
    key: "warn",
    value: function warn(message) {
      isDev && console.warn(message);
    }
  }, {
    key: "deprecate",
    value: function deprecate(message) {
      isDev && console.warn('DEPRECATION::: ', message);
    }
  }]);
}();

export { Logger as L, _createClass as _, _classCallCheck as a };
//# sourceMappingURL=logger-4df3b60c.js.map
